import { Search } from './search'

export default Search
